import { PmInvalidFieldEnum } from '../enums/PmInvalidFieldEnum';
import { IInvalidField } from './knmInvalidFields';

export const pmInvalidFields: Record<PmInvalidFieldEnum, IInvalidField> = {
  [PmInvalidFieldEnum.PROSECUTOR_ORGANIZATION_ERKNM]: {
    name: 'Орган прокуратуры',
  },
  [PmInvalidFieldEnum.PM_REASONS_ERKNM_ERVK_UUID]: {
    name: 'Основание проведения ПМ',
  },
  [PmInvalidFieldEnum.PM_REASONS_ERKNM_ORDER]: {
    name: 'Поручение основания',
  },
  [PmInvalidFieldEnum.PM_REASONS_ERKNM_RISK_INDICATORS]: {
    name: 'Индикаторы риска основания',
  },
  [PmInvalidFieldEnum.PM_REASONS_ERKNM_RISK_INDICATOR]: {
    name: 'Индикаторы риска основания',
  },
  [PmInvalidFieldEnum.PM_SUPERVISION_TYPE]: {
    name: 'Вид государственного контроля (надзора)',
    required: true,
  },
  [PmInvalidFieldEnum.PM_KNO_ORGANIZATION]: {
    name: 'Наименование органа контроля',
    required: true,
  },
  [PmInvalidFieldEnum.PM_TYPE]: {
    name: 'Вид профилактического мероприятия',
  },
  [PmInvalidFieldEnum.PM_EVENTS_ERKNM_TYPE]: {
    name: 'Перечень действий',
  },
  [PmInvalidFieldEnum.PM_REQUIREMENTS_NPA_ID]: {
    name: 'Обязательные требования, подлежащие проверке (НПА)',
  },
  [PmInvalidFieldEnum.PM_REQUIREMENTS_NPA_STRUCTURAL_UNIT_ID]: {
    name: 'Обязательные требования, подлежащие проверке (Структурные единицы)',
  },
  [PmInvalidFieldEnum.PM_ORGANIZATIONS_SUBJECT_TYPE]: {
    name: 'Тип контролируемого лица',
  },
};
